import { getFirestore, doc, collection, query, where, getDocs, deleteDoc } from 'firebase/firestore'
import Streak from '@/models/streak'
import { useToolStore } from '@/stores/tool'

export default class Plan {
  constructor(id, active, startDate, toolIds, stages, type) {
    this.id = id
    this.active = active
    this.startDate = startDate
    // this.lessons = lessons
    this.stages = stages
    this.type = type
    this._toolIds = toolIds
    this._ref = this.ref
  }

  static convert(object) {
    return new Plan(
      object.plan_id,
      object.active,
      object.start_date,
      // TODO: Extrapolate using store? Or leave as list of IDs..?
      object.tools,
      object.stages.map(stage => Stage.convert(stage)),
      object.plan_type,
    )
  }

  get ref() {
    if (!this._ref) {
      this._ref = doc(getFirestore(), 'plans', this.id).withConverter(Plan.firestoreConverter())
    }
    return this._ref
  }

  get tools() {
    if (!this._toolIds) return undefined
    const getTools = async () => {
      const toolStore = useToolStore()
      await toolStore.load()
      return toolStore.getTools(this._toolIds)
    }
    return getTools()
  }

  async delete() {
    await deleteDoc(this.ref)
  }

  static firestoreConverter() {
    return {
      // TODO: Complete this When writing plans to Firestore is required.
      // toFirestore: (plan) => {
      //   return {
      //     x: plan.x,
      //   }
      // },
      fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        return new Plan(
          snapshot.id,
          data.active,
          data.start_date,
          data.tools,
          data.stages.map(stage => Stage.convert(stage)),
          data.plan_type,
        )
      }
    }
  }

  static collection() {
    return collection(getFirestore(), 'plans').withConverter(Plan.firestoreConverter())
  }

  static async getByUser(uid) {
    const userRef = doc(getFirestore(), 'users', uid)
    const q = query(
      Plan.collection(),
      where('uuid', '==', userRef),
    )
    const snap = await getDocs(q)
    return snap.docs.map(doc => doc.data())
  }
}

export class Stage {
  constructor(index, target, streakRef, state) {
    this.index = index
    this.target = target
    this.state = state
    this._streakId = streakRef?.split('/')[1]
    this._streak = this.streak
    this._startDate = this.startDate
  }

  static convert(object) {
    return new Stage(
      object.stage,
      Target.convert(object.target),
      object.streak, // This is a reference to the streak object.
      object.state
    )
  }

  get streak() {
    if (!this._streakId) return undefined
    if (!this._streak) {
      this._streak = Streak.get(this._streakId)
    }
    return this._streak
  }

  get startDate() {
    if (!this._startDate) {
      const getStreak = async () => {
        const streak = await this.streak
        const first = streak?.streak.reduce((max, s) => {
          return max.date > s.date ? max : s
        })
        this._startDate = first?.date
      }
      return getStreak()
    }
    return this._startDate
  }

  // From the `StageState(Enum)` class in the backend service.
  static STATE_SUCCESS = 'SUCCESSFUL'
  static STATE_FAILED = 'FAILED'
  static STATE_ACTIVE = 'ACTIVE'
  static STATE_INACTIVE = 'INACTIVE'
}

export class Target {
  constructor(bedTime, wakeTime, duration) {
    this.bedTime = bedTime
    this.wakeTime = wakeTime
    this.duration = duration
  }

  static convert(object) {
    return new Target(
      object.bed_time,
      object.wake_time,
      object.duration,
    )
  }
}